<template>
    <div class="w-h-100" style="background:#fff;">
        <div class="flex just-between" style="padding: 20px;">
            <div>
                <el-button size="small" icon="el-icon-plus" type="primary" @click="handleAdd">新增图片</el-button>
            </div>
            <div class="flex align-center">
                <div>启用状态：</div>
                <el-select v-model="queryForm.enabled" placeholder="启用状态" size="small" clearable>
                    <el-option :value="true" label="启用"></el-option>
                    <el-option :value="false" label="停用"></el-option>
                </el-select>
                <el-button style="margin-left:10px;" type="primary" icon="el-icon-search" size="small" @click="getImageList(queryForm)">查询</el-button>
            </div>
        </div>
        <div style="padding:0 20px;">
            <el-table
                :data='imageList'
                :header-cell-style="{textAlign: 'center',background: '#409EFF',color: '#fff'}"
                :cell-style="{textAlign: 'center'}"
                style="width:100%;border:none;">
                <el-table-column type='index' label='序号' width="60"></el-table-column>
                <el-table-column prop="url" label="链接地址"></el-table-column>
                <el-table-column prop="sort" label="排序码"></el-table-column>
                <el-table-column prop="imageUrl" label="图片" class="flex just-center">
                    <template slot-scope="scope">
                        <div>
                            <img style="width:100px;height:30px;" :src=scope.row.imageUrl>
                        </div>
                    </template>
                </el-table-column>
                <el-table-column prop="enabled" label="状态">
                    <template slot-scope="scope">
                        <el-switch v-model="scope.row.enabled"
                        :inactive-value="false"
                        :active-value="true"
                        @change="changeStatus(scope.row)"></el-switch>
                    </template>
                </el-table-column>
                <el-table-column label="操作" width="200">
                    <template slot-scope="scope">
                        <el-button size="small" icon="el-icon-edit" style="margin-right:10px;" @click="handleEdit(scope.row)">修改</el-button>
                        <el-button size="small" icon="el-icon-delete" @click="handleDelete(scope.row)">删除</el-button>
                    </template>
                </el-table-column>
            </el-table>
            <el-pagination
                style="margin: 20px 0"
                layout="->, prev,pager,next,total,sizes,jumper"
                @size-change="changeSize"
                @current-change="changeCurrent"
                :page-size="pageData.pageSize"
                :page-sizes="['10', '20', '30', '40', '50']"
                :current-page="pageData.pageNum"
                :pager-count="7"
                :total="total">
            </el-pagination>
        </div>
        <el-dialog
            style="text-align:left;color:#fff;"
            :title="addFlag ? '新增' : '修改'"
            @close='addCancle'
            :close-on-click-modal="false"
            :visible.sync = "addDialog"
            width="600px">
            <el-form :model="formData" :rules="rules" ref="ruleForm" label-width="120px">
                <el-form-item label="链接地址" prop="url">
                    <el-input placeholder="请输入链接地址" v-model="formData.url" style="width: 300px"></el-input>
                </el-form-item>
                <el-form-item label="状态" prop="enabled">
                    <el-switch v-model="formData.enabled"
                        :inactive-value="false"
                        :active-value="true">
                    </el-switch>
                </el-form-item>
                <el-form-item label="排序" prop="sort">
                    <el-input placeholder="请输入排序" v-model="formData.sort" style="width: 300px"></el-input>
                </el-form-item>
                <el-form-item label="图片" prop="imageId">
                    <el-upload ref="imgUpload"
                        :limit="1"
                        style="display: inline"
                        :http-request="uploadMethod"
                        :on-change="handleChange"
                        :before-upload="beforeUpload"
                        :action="uploadUrl">
                        <div v-if="!imageUrl" style="width:150px;height:150px;border:1px dashed #ddd;line-height:150px;text-align:center;">
                            <i class="el-icon-plus" style="font-size:40px;color:#ddd;"></i>
                        </div>
                        <div v-else style="width:150px;height:150px;">
                            <img class="w-h-100" :src="imageUrl" alt="">
                            <span>{{imgName}}</span>
                        </div>
                    </el-upload>
                </el-form-item>
            </el-form>
            <div style="text-align:right;">
                <el-button size="small" @click="addCancle" class="queding-btn">取消</el-button>
                <el-button size="small" type="primary" @click="addConfirm" class="queding-btn">确定</el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script>
/* eslint-disable no-debugger */
/* eslint-disable prefer-const */
import axios from 'axios'
export default {
    data() {
        return {
            total: 0,
            queryForm: {
                enable: null
            },
            disabled: false,
            addDialog: false,
            imageList: [],
            addFlag: true,
            formData: {
                imageId: '',
                url: '',
                sort: '',
                enabled: false
                // status: ''
            },
            rules: {
                sort: [{ required: true, message: '请输入排序码', trigger: 'blur' },
                { pattern: /^[0-9]\d*$/, message: '排序码需为正整数', trigger: 'blur' }],
                imageId: [{ required: true, message: '请上传图片', trigger: 'change' }],
                url: [{ required: true, message: '请输入链接地址', trigger: 'blur' }]
            },
            imageUrl: '',
            fileList: [],
            fileDataList: [], // 在上传文件按钮后渲染数据数组
            uploadUrl: '/admin/api/website/attachment',
            pageData: {
                pageSize: 10,
                pageNum: 1
            },
            imgName: ""
        }
    },
    methods: {
        changeSize (value) {
            this.pageData.pageSize = value
            if (this.queryForm.enabled || !this.queryForm.enabled) {
                this.getImageList(this.queryForm)
            } else {
                this.getImageList()
            }
        },
        changeCurrent (value) {
            this.pageData.pageNum = value
            if (this.queryForm.enabled || !this.queryForm.enabled) {
                this.getImageList(this.queryForm)
            } else {
                this.getImageList()
            }
        },
        addCancle () {
            this.formData = {
                imageId: '',
                url: '',
                sort: '',
                status: ''
            }
            this.imageUrl = ''
            this.addDialog = false
            this.$refs.imgUpload?.clearFiles()
        },
        addConfirm () {
            this.$refs.ruleForm.validate(valid => {
                if (valid) {
                    if (this.addFlag) {
                        this.$api.imageConfig.handleAddImage(this.formData).then(res => {
                            if (res.code === 200) {
                                this.$message({
                                    type: 'success',
                                    message: '新增成功'
                                })
                                this.addDialog = false
                            }
                        })
                    } else {
                        this.$api.imageConfig.editSetting(this.formData).then(res => {
                            if (res.code === 200) {
                                this.$message({
                                    type: 'success',
                                    message: '修改成功'
                                })
                                this.addDialog = false
                            }
                        })
                    }
                    setTimeout(() => {
                        this.getImageList()
                    }, 500)
                }
            })
        },
        handleAdd () {
            this.formData = {
                imageId: '',
                url: '',
                sort: '',
                enabled: false
            }
            this.addFlag = true;
            this.addDialog = true
            this.$refs.ruleForm?.resetFields();
        },
        changeSelect () {
            this.$forceUpdate()
        },
        getImageList (data) {
            const param = {
                pageSize: this.pageData.pageSize,
                pageNum: this.pageData.pageNum,
            }
            if (data) {
                param.enabled = data.enabled
            }
            this.$api.imageConfig.getPictureList(param).then(res => {
                if (res.code === 200) {
                    if (res.data.content.length > 0) {
                        res.data.content.forEach(item => {
                            if (item.attachment && item.attachment.url) {
                                item.imageUrl = item.attachment.url
                            }
                        })
                    }
                    this.imageList = res.data.content || []
                    this.total = res.data.totalElements
                }
            })
        },
        changeStatus (data) {
            const param = {
                id: data.id,
                status: data.enabled
            }
            this.$api.imageConfig.editEnabled(param).then(res => {
                if (res.code === 200) {
                    this.$message.success('状态变更成功')
                } else {
                    this.$message.error(res.message)
                }
            })
        },
        handleChange () {},
        handleEdit (row) {
            this.formData = {
                imageId: '',
                url: '',
                sort: '',
                enabled: false
            }
            this.$refs.ruleForm?.resetFields();
            const param = {
                id: row.id
            }
            this.$api.imageConfig.getSettingInfo(param).then(res => {
                if (res.code === 200) {
                    this.addFlag = false
                    this.addDialog = true
                    this.imageUrl = res.data.attachment.url
                    this.imgName = res.data.attachment.name + res.data.attachment.type;
                    this.formData = res.data
                }
            })
        },
        handleDelete (data) {
            this.$confirm('确定要删除该数据吗?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                const param = {
                    id: data.id
                }
                this.$api.imageConfig.deleteImage(param).then(res => {
                    if (res.code === 200) {
                        this.$message.success('删除成功')
                        this.getImageList()
                    } else {
                        this.$message.error(res.message)
                    }
                })
            }).catch(() => {
                this.$message.info('取消删除')
            })
        },
        uploadMethod (obj) {
            let fd = new FormData()
            fd.append('file', obj.file)
            this.$api.imageConfig.imageUpload(fd).then((res) => {
                if (res.code === 200) {
                    this.formData.imageId = res.data.id
                    this.imgName = res.data.name + res.data.type;
                    this.imageUrl = res.data.url
                    this.$message({
                        type: 'success',
                        message: '上传成功'
                    })
                    this.$refs.imgUpload?.clearFiles();
                } else {
                    this.$message({
                        type: 'error',
                        message: res.message
                    })
                }
            })
        },
        beforeUpload (file) {
            if (file.type?.indexOf("image") === -1) {
                this.$message.error("请上传jpg/jpeg/png格式的图片");
                return false;
            }
            const isOutSize = file.size / 1024 / 1024 < 20
            if (!isOutSize) {
                this.$message.warning('上传文件大小不能超过 20MB!');
                return false;
            }
        },
    },
    mounted() {
        this.getImageList()
    },
}
</script>

<style scoped lang='less'>
</style>
